<template>
	<!-- Navbar start -->
	<NavbarElement :activeSection="activeSection" />
	<!-- Navbar end -->

	<router-view @sections-ready="setupIntersectionObserver"></router-view>

	<!-- Footer start -->
	<FooterElement :activeSection="activeSection" />
	<!-- Footer end -->
</template>

<script>
import NavbarElement from '@/components/NavbarElement.vue';
import FooterElement from '@/components/FooterElement.vue';
// import LoadingElement from '@/components/LoadingElement.vue';

export default {
	components: {
		FooterElement,
		NavbarElement,
		// LoadingElement
	},
	data() {
		return {
			activeSection: 'home',
			observer: null,
			// loading: false
		}
	},
	mounted() {
	},
	methods: {
		setupIntersectionObserver() {
			this.observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						this.activeSection = entry.target.id;
					}
				});
			}, { threshold: 0.2 });

			['home', 'services', 'features', 'house-games', 'projects', 'partners', 'pricing'].forEach((id) => {
				const element = document.getElementById(id);
				if (element) this.observer.observe(element);
			});
		}
	},
}
</script>
